module.exports = __webpack_public_path__ + "static/media/come-funziona-lavoratore-02.f22fc372.png";